module.exports = __webpack_public_path__ + "images/f6efd6a57420400d2621c9f1fd88bb88.svg";


//////////////////
// WEBPACK FOOTER
// ../public/images/icons/work.svg
// module id = 1036
// module chunks = 0